
import styles from './block.module.sass'

import BlockWrapper from './layout/block_wrapper'

import library from './library'

import ld from 'lodash'
const __ = ld.noConflict()

function Block(props) {
	const fields = props.fields

	const renderedComponents = []

	__.each(fields, (component, i) => {
		const type = component.name

		const Component = library[type];
		const renderedComponent = <Component key={`component_${type}_${i}`} {...component} />

		renderedComponents.push(renderedComponent)
	})

	return <BlockWrapper {...props} className={styles.block_parent}>
		{renderedComponents}
	</BlockWrapper>
}

export default Block